import { mediaQueryMatcherAtom } from "@/modules/main/mediaQueryMatcherAtom.ts";
import { atomWithLocalStorage } from "@/utils/jotai/atomStorage.ts";
import { useSetAtom } from "jotai";
import { atom } from "jotai/vanilla";
import { useLayoutEffect } from "react";

export type ColorSchemeValue = "light" | "dark";
export type ColorSchemeMode = ColorSchemeValue | "auto";

export const savedColorSchemeAtom = atomWithLocalStorage<ColorSchemeMode>("colorSchemeMode", "auto");

const darkModeMatcherAtom = mediaQueryMatcherAtom("(prefers-color-scheme: dark)");

/** Allow temporarily overriding the current color scheme */
const forcedColorSchemeAtom = atom<ColorSchemeValue | undefined>(undefined);

export const currentColorSchemeAtom = atom<ColorSchemeValue>((get) => {
    const forcedColorScheme = get(forcedColorSchemeAtom);
    if (forcedColorScheme) {
        return forcedColorScheme;
    }

    const savedColorScheme = get(savedColorSchemeAtom);
    if (savedColorScheme !== "auto") {
        return savedColorScheme;
    }

    const darkModePreferred = get(darkModeMatcherAtom);
    return darkModePreferred ? "dark" : "light";
});

export function useForceLightMode() {
    const setForcedColorScheme = useSetAtom(forcedColorSchemeAtom);
    useLayoutEffect(() => {
        setForcedColorScheme("light");
        return () => {
            setForcedColorScheme(undefined);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
